// TODO(IP): placeholder marks — replace with licensed carrier logos before pitch/production.
//
// These are ORIGINAL generic glyphs (a shield/roof for Citizens, an "SF"
// monogram for State Farm), NOT the carriers' proprietary logos. They are
// swappable registry assets — see registry.ts (BrandDef.Logo). Do not ship
// real carrier logos we don't have rights to.

/** Props for a brand mark — same signature as the V2 Logo. */
export interface BrandMarkProps {
  /** Square edge length in px (default 18). */
  size?: number;
}

/**
 * Citizens placeholder mark — generic shield/roof glyph.
 * Ported from design_reference/js/shell.jsx CitizensMark.
 *
 * @param props - Optional size.
 * @returns The SVG mark element.
 */
export function CitizensMark({ size = 18 }: BrandMarkProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 2.6 4 5.4v6.1c0 4.5 3.4 7.8 8 9.3 4.6-1.5 8-4.8 8-9.3V5.4L12 2.6Z"
        fill="var(--cz-navy)"
      />
      <path
        d="M7.4 12.6 12 8.8l4.6 3.8"
        stroke="#fff"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.7 12v4.2h6.6V12"
        stroke="var(--cz-gold)"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/**
 * State Farm placeholder mark — "SF" monogram on a red field.
 *
 * @param props - Optional size.
 * @returns The SVG mark element.
 */
export function StateFarmMark({ size = 18 }: BrandMarkProps) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <rect x="2.5" y="2.5" width="19" height="19" rx="5" fill="var(--sf-red, #ed1d24)" />
      <text
        x="12"
        y="16"
        textAnchor="middle"
        fontFamily="system-ui, -apple-system, sans-serif"
        fontSize="11"
        fontWeight="800"
        letterSpacing="-0.02em"
        fill="#fff"
      >
        SF
      </text>
    </svg>
  );
}
